<script>
  export let padding = '16px';
  export let hover = true;
</script>

<div class="glow-card" class:hovered={hover} style={`--pad:${padding};`}>
  <div class="glow-border"></div>
  <div class="content glass" style="padding: var(--pad);">
    <slot />
  </div>
  <div class="glow"></div>
</div>

<style>
  .glow-card { position: relative; border-radius: var(--r-m); }
  .glow-border { position:absolute; inset: -1px; border-radius: inherit; padding: 1px;
    background: linear-gradient(120deg, rgba(0,255,198,.35), rgba(33,243,255,.35), rgba(124,255,91,.35));
    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor; mask-composite: exclude;
    pointer-events: none; opacity: .65;
  }
  .content { position: relative; border-radius: inherit; }
  .glow { position:absolute; inset: 0; border-radius: inherit; pointer-events: none; box-shadow: var(--card-glow); }
  .hovered:hover { transform: translateY(-2px); transition: transform var(--speed-2) var(--e-out); }
</style>

